import React, { useState } from 'react';
import HealthInsuranceManager from './HealthInsuranceManager';
import HealthInsurancePayouts from './HealthInsurancePayouts';
import HealthInsurancePaidHistory from './HealthInsurancePaidHistory';

const HealthInsuranceWrapper = () => {
    const [activeTab, setActiveTab] = useState('policies');

    const renderContent = () => {
        switch (activeTab) {
            case 'policies':
                return <HealthInsuranceManager />;
            case 'payouts':
                return <HealthInsurancePayouts />;
            case 'history':
                return <HealthInsurancePaidHistory />;
            default:
                return <HealthInsuranceManager />;
        }
    };

    return (
        <div className="space-y-6">
            <div className="bg-white p-2 rounded-lg shadow-sm border border-gray-100 flex space-x-2">
                <button
                    onClick={() => setActiveTab('policies')}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${activeTab === 'policies'
                            ? 'bg-indigo-100 text-indigo-700'
                            : 'text-gray-600 hover:bg-gray-50'
                        }`}
                >
                    Policies Management
                </button>
                <button
                    onClick={() => setActiveTab('payouts')}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${activeTab === 'payouts'
                            ? 'bg-indigo-100 text-indigo-700'
                            : 'text-gray-600 hover:bg-gray-50'
                        }`}
                >
                    Payouts Processing
                </button>
                <button
                    onClick={() => setActiveTab('history')}
                    className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${activeTab === 'history'
                            ? 'bg-indigo-100 text-indigo-700'
                            : 'text-gray-600 hover:bg-gray-50'
                        }`}
                >
                    Paid History
                </button>
            </div>

            <div className="mt-4">
                {renderContent()}
            </div>
        </div>
    );
};

export default HealthInsuranceWrapper;
